export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const API_KEY = '74d29b03-cfa9-4fb6-95eb-964ef984d931';
export const MODAL_CLOSE_SEC = 2.5;
